require('initializers/gettext').default(__TRANSLATIONS__.gettext.en); // eslint-disable-line no-undef
require('initializers/i18n').default('en', __TRANSLATIONS__.i18n.en); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/en');
